import { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Tv2, Code2, Braces, Image } from "lucide-react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TitleBar from "./components/TitleBar";
import ActivityBar from "./components/ActivityBar";
import TabBar from "./components/TabBar";
import StatusBar from "./components/StatusBar";
import { StatusBarProvider } from "./context/StatusBarContext";
import Home from "./pages/Home";
import Landing from "./pages/Landing";
import WebDevEditor from "./pages/webDevEditor";
import SvgEditor from "./pages/SvgEditor";
import AI from "./pages/ai";

const TOOLS = [
  { path: "/", label: "Welcome", icon: Tv2 },
  { path: "/compiler", label: "Compiler", icon: Braces },
  { path: "/web", label: "Web Editor", icon: Code2 },
  { path: "/svg", label: "SVG Editor", icon: Image },
];

function App() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [openTabs, setOpenTabs] = useState([TOOLS[0]]);

  useEffect(() => {
    const match = TOOLS.find((tool) => tool.path === pathname);
    if (match) {
      setOpenTabs((prev) =>
        prev.some((tab) => tab.path === match.path) ? prev : [...prev, match]
      );
    }
  }, [pathname]);

  const closeTab = (path) => {
    setOpenTabs((prev) => {
      const next = prev.filter((tab) => tab.path !== path);
      if (next.length === 0) {
        navigate("/");
        return [TOOLS[0]];
      }
      if (pathname === path) {
        navigate(next[next.length - 1].path);
      }
      return next;
    });
  };

  const activeTool = TOOLS.find((tool) => tool.path === pathname);

  return (
    <StatusBarProvider>
      <div className="flex h-screen flex-col bg-vscode-bg font-ui text-vscode-text">
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
        <TitleBar />
        <div className="flex flex-1 overflow-hidden">
          <ActivityBar tools={TOOLS} />
          <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
            <TabBar openTabs={openTabs} onClose={closeTab} />
            <div className="flex-1 overflow-auto">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/compiler" element={<Landing />} />
                <Route path="/svg" element={<SvgEditor />} />
                <Route path="/web" element={<WebDevEditor />} />
                <Route path="/ai" element={<AI />} />
              </Routes>
            </div>
          </div>
        </div>
        <StatusBar toolLabel={activeTool?.label} toolIcon={activeTool?.icon} />
      </div>
    </StatusBarProvider>
  );
}

export default App;
